<div class="layout">
  <header class="trustee-header">
    <nav>
      <div class="logos">
        <img src="assets/img/brand/gt-tmnz.png" alt="Trustee and TMNZ Logo" />
        <img class="mobile" src="assets/img/brand/icon.png" alt="GT Logo" />
      </div>
      <div class="actions">
        <span class="username">{{ fullName }}</span>
        <button (click)="logout()">
          <i class="cui-account-logout icons font-2xl d-block logout"></i>
        </button>
      </div>
    </nav>
  </header>
  <main>
    <c-sidebar
      #trusteeSidebar="cSidebar"
      id="trustee-sidebar"
      class="sidebar sidebar-dark"
      [visible]="sidebarVisible"
      [unfoldable]="sidebarUnfoldable"
      [position]="'sticky'"
      (visibleChange)="handleSidebarVisibilityChange($event)"
    >
      <c-sidebar-nav [navItems]="navItems"></c-sidebar-nav>
    </c-sidebar>

    <div class="main">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
      <footer>
        <span>
          Courtesy of <a href="https://tmnz.co.nz">TMNZ</a> &copy; {{ currentYear }}
        </span>
      </footer>
    </div>
  </main>
</div>
